export default "__VITE_ASSET__CQuh3_BS__"